import {GradientGenerator} from '@shortsworks/ui/components/ColorGenerator/GradientGenerator';
import {GradientColor, GradientType} from '@shortsworks/ui/components/ColorGenerator/GradientGenerator/types';
import {useEffect, useState} from 'react';

export const defaultGradientColor = (startColor: string = '#BC3BE9') => GradientColor.new(
  GradientType.Linear,
  [
    {color: startColor, offset: 0},
    {color: '#EC702B', offset: 1},
  ],
  0,
);

export interface ColorSelectorValue {

}

export interface ColorSelectorProps {
  defaultValue?: GradientColor;
  onChange: (value: ColorSelectorValue) => void;
}

export const ColorGenerator = ({ onChange, defaultValue = defaultGradientColor()}: ColorSelectorProps) => {
  const [ gradientColor, setGradientColor ] = useState<GradientColor>(defaultValue);

  // 비동기 데이터 처리 등의 formValues 가 변경 후에 변경되지 않는 점 수정
  useEffect(() => {
    if(defaultValue) {
      setGradientColor(defaultValue);
    }
  }, [gradientColor]);

  const handleColorChange = (gradientColor: GradientColor) => {
    setGradientColor(gradientColor);
    onChange?.(gradientColor);
  }

  return (
    <GradientGenerator
      gradientColor={gradientColor}
      onColorChange={handleColorChange}
    />
  )
}
